import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from './DomElements.scss';
import Label from './Label';

const NumberInput = (props) => {
    const {
        onChange,
        value,
        label,
        autoFocus,
        onKeyDown,
        containerClassName,
        containerStyle,
        disabled,
        placeholder,
        inputStyle,
        min,
        max,
        step,
    } = props;

    return (
        <div
            className={cx(Styles.domElContainer, containerClassName)}
            style={containerStyle}
        >
            {label && <Label text={label} />}
            <input
                id="subset-amount-input"
                type="number"
                className={Styles.textbox}
                onChange={onChange}
                value={value}
                autoFocus={autoFocus}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                disabled={disabled}
                style={inputStyle}
                min={min}
                max={max}
                step={step}
            />
        </div>
    );
};

NumberInput.propTypes = {
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    value: PropTypes.any,
    label: PropTypes.string,
    autoFocus: PropTypes.bool,
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
};

export default NumberInput;
